/**
 * O texto na forma em que a busca compara: sem acento e em minúscula.
 *
 * Casa "Sao Paulo" com "São Paulo" e "premiacao" com "Premiação". Mora num
 * arquivo próprio porque `MultiSelect` e `SearchSelect` buscam do mesmo jeito,
 * e duas cópias desta função seriam duas respostas para "o que a busca acha".
 */
export function folded(text: string): string {
  return text
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase();
}
